import { Minus } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { SeparatorEditorRenderer } from "./editor";
import { SeparatorEmailRenderer } from "./email";
import type { SeparatorBlockProps, SeparatorSpacing } from "./types";
import { SeparatorWeb } from "./web";
import { SeparatorWebEditor } from "./web-editor";
import { SeparatorEmailPanelRenderer } from "./email-panel";

export function mapSeparatorSpacingToPixels(spacing?: SeparatorSpacing) {
  switch (spacing) {
    case "small":
      return 12;
    case "default":
      return 24;
    case "large":
      return 40;
    default:
      return 24;
  }
}

export default registerBlock<SeparatorBlockProps>({
  type: "separator",
  name: "editorBlocksLibrary.blocks.separator.title",
  description: "editorBlocksLibrary.blocks.separator.description",
  Icon: Minus,
  category: BlockCategory.LAYOUT,
  components: {
    email: {
      component: SeparatorEmailRenderer,
      editor: {
        component: SeparatorEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: SeparatorEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: SeparatorWeb,
      editor: {
        component: SeparatorWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { SeparatorBlockProps as SeparatorEditorRendererProps } from "./types";
